export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6701.b5de18b6.jpg";